<template>
  <div class="sever">
    <div class="content_banner">
      <img src="../../assets/img/banner/banner_server.jpg" alt="">
    </div>

    <div class="container_wrap">
      <el-row :gutter="30">
        <el-col :span="5">
          <div class="side_hd">
            <h2>项目展示</h2>
            <p>ITEM SHOW</p>
          </div>
          <div class="side_wrap">
            <ul>
              <li v-for="(item,index) in sideNav" :class="{'active' : cur == item.id}" :key="index" @click="sideNavActice(item,index)">
                <a href="javascript:;">{{item.name}}</a>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="contTit">
            <h2>项目展示</h2>
            <p><router-link to="/">首页</router-link> · <a href="/project">项目展示</a> · <span>{{titleRight}}</span></p>
          </div>
          <div class="contRWrap">
            <ul class="cont_list">
              <li v-for="(item,index) in list" :key="index">
                <router-link
                :to="'/projectDetail?id='+item.id" 
                class="clearfloat" 
                :class="{'newslist_new':dayjs(item.updateTime).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD')}"
                >
                  <div class="fr">{{dayjs(item.updateTime).format('YYYY-MM-DD')}}</div>
                  <div class="inner single-line">{{item.name}}</div>
                </router-link>
              </li>
            </ul>

            <div class="cont_list_pag">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :current-page="currentPage"
                @current-change = "currentPag">
              </el-pagination>
            </div>

          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news',
  data(){
    return{
      cur: 0,
      sideNav: [],
      titleRight: '',
      list: [],
      total: 10,
      currentPage: 1,
      id: ''
    }
  },
  mounted: function(){

  },
  created: function(){
    var _this = this

    _this.getSeverNav()

    var urlId = _this.$router.history.current.query.id

    setTimeout(() => {
      if(urlId){
        _this.cur = urlId
        _this.id = urlId
        _this.sideNav.forEach(line =>{
          if(line.id == urlId){
            _this.titleRight = line.name
          }
        })
      }else{
        _this.cur = _this.sideNav[0].id
        _this.id = _this.sideNav[0].id
        _this.titleRight = _this.sideNav[0].name
      }
      _this.getDetail(urlId, _this.currentPage)
    }, 500)
  },
  watch: {
    '$route': function () {
      var _this = this
      if(_this.$route.meta){
        _this.cur = _this.$route.meta.sub ? _this.$route.meta.sub : 0
      }

      var urlId = _this.$router.history.current.query.id
      if(urlId){
        _this.cur = urlId
        _this.id = urlId
        _this.sideNav.forEach(line =>{
          if(line.id == urlId){
            _this.titleRight =  line.name
          }
        })
      }else{
        _this.cur = _this.sideNav[0].id
        _this.id = _this.sideNav[0].id
        _this.titleRight = _this.sideNav[0].name
      }
      _this.getDetail(_this.id, _this.currentPage)
    }
  },
  methods: {
    // 侧导航
    sideNavActice(item,index){
      console.log('index :>> ', index);
      var _this = this

      _this.cur = item.id
      _this.titleRight = item.name
      _this.getDetail(item.id, _this.currentPage)
    },
    async getSeverNav(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/project/getProjectTypeList');
      if(data.code == 200){
        _this.sideNav = data.data
      }
    },
    currentPag(index){
      var _this = this
      _this.getDetail(_this.id, index)
    },
    async getDetail(id,index){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/project/getProjectInfoList',{page: index, classification: id});
      if(data.code == 200){
        _this.list = data.data.list
        _this.total = data.data.total
      }
    }
  }
}
</script>